'use client';
import PropTypes from 'prop-types';
import React__default from 'react';
import { useIsSafariVersion18 } from '../../hooks/use-is-safari-version-18.js';
import { TransitionStatus } from '../../hooks/use-transition.js';
import { useInternalDialogConfigContext } from './dialog.component.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * removes the padding around the dialog's content
   */ fullBleed: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
/**
 * @subcomponent Dialog
 */ const ModalDialogContent = renderWithRef('ModalDialogContent', propTypes, (props, ref)=>{
    const { bgc, backgroundColor, variant, takeOver, footerPinned, bodyWidth, transitionState, isModal } = useModalDialogContext();
    const { portalRef } = useInternalDialogConfigContext();
    const { fullBleed, children } = props;
    const wrapperClassName = new Set([
        'swan-modal-dialog'
    ]);
    if (!isModal) wrapperClassName.add('swan-modeless-dialog');
    if (fullBleed) wrapperClassName.add('swan-modal-dialog-skin-full-bleed');
    if (TransitionStatus.ENTERED === transitionState) wrapperClassName.add('swan-modal-dialog-visible');
    if (variant && [
        'panel-right',
        'panel-left',
        'panel-bottom',
        'panel-top',
        'menu'
    ].includes(variant)) wrapperClassName.add('swan-modal-dialog-panel');
    if (variant && [
        'panel-left',
        'menu'
    ].includes(variant)) wrapperClassName.add('swan-modal-dialog-panel-left');
    if (variant && [
        'panel-right',
        'panel-left',
        'panel-bottom',
        'panel-top',
        'menu'
    ].includes(variant) && bodyWidth === 'capped') wrapperClassName.add('swan-modal-dialog-panel-capped');
    if (bodyWidth === 'grow') wrapperClassName.add('swan-modal-dialog-grow');
    if (variant === 'panel-bottom') wrapperClassName.add('swan-modal-dialog-panel-bottom');
    if (variant === 'panel-top') wrapperClassName.add('swan-modal-dialog-panel-top');
    if (variant === 'menu') wrapperClassName.add('swan-modal-dialog-panel-menu');
    if (takeOver) wrapperClassName.add('swan-modal-dialog-takeover');
    if (footerPinned) wrapperClassName.add('swan-modal-dialog-panel-pinned');
    const isSafari18 = useIsSafariVersion18();
    const style = _object_spread({}, props.style);
    if (isSafari18) {
        style.minHeight = '-webkit-fill-available';
        style.maxHeight = '-webkit-fill-available';
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        classNames: wrapperClassName,
        props: _object_spread_props(_object_spread({
            bgc,
            backgroundColor
        }, props), {
            style
        }),
        propKeysToRemove: propKeysToRemove
    }, children), /*#__PURE__*/ React__default.createElement("div", {
        ref: portalRef
    }));
});

export { ModalDialogContent };
